import { View } from "@/components/ui";
import { ReferralSectionHero } from "./referral-section-hero";
import { ReferralSectionHowItWorks } from "./referral-section-how-it-works";
import { ReferralSectionHistory } from "./referral-section-history";

export const AccountMyReferral = () => {
  return (
    <View className="flex flex-col gap-4">
      <ReferralSectionHero />
      <ReferralSectionHowItWorks />
      <ReferralSectionHistory />
    </View>
  );
};
